import { ApiError } from '@/api/errors';

interface ErrorBody {
  error?: { code?: string; message?: string; details?: Record<string, unknown> };
}

/**
 * Guarda un archivo que devolvió la API (`api.GET(..., { parseAs: 'blob' })`) con el nombre de
 * `Content-Disposition` (la API lo expone por CORS en `/admin`).
 */
export function guardarArchivo(
  resultado: { data?: Blob; error?: unknown; response: Response },
  nombrePorOmision: string,
): void {
  const { data, error, response } = resultado;
  if (!response.ok || !data) {
    const e = (error ?? {}) as ErrorBody;
    throw new ApiError(
      response.status,
      e.error?.code ?? 'HTTP_ERROR',
      e.error?.message ?? 'No pudimos generar el archivo. Inténtalo de nuevo.',
      e.error?.details ?? {},
    );
  }
  const disp = response.headers.get('Content-Disposition') ?? '';
  const nombre = /filename="([^"]+)"/.exec(disp)?.[1] ?? nombrePorOmision;
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
